module.exports = __webpack_public_path__ + "img/count.b2cdc80f.png";